import type { ReactNode } from 'react'

interface KickerProps {
  color?: string
  live?: boolean
  children: ReactNode
}

export function Kicker({ color, live = false, children }: KickerProps) {
  return (
    <div className="kicker inline-flex items-center" style={color ? { color } : undefined}>
      {live && <span className="live-dot" style={color ? { background: color, color } : undefined} />}
      <span>{children}</span>
    </div>
  )
}
